import { supabase } from './supabase';

export const DEACTIVATED_TEAM_REASON =
  'Your team account has been deactivated. Please contact your administrator.';

/** Whether this signed-in person may open the app. Owners and active team members may. A login whose team profiles are all deactivated may not. */
export async function callerTeamAccess(): Promise<'allowed' | 'deactivated'> {
  if (!supabase) return 'allowed';
  const { data, error } = await supabase.rpc('caller_team_access');
  if (error) {
    console.error('caller_team_access failed:', error.message);
    return 'allowed';
  }
  return data === 'deactivated' ? 'deactivated' : 'allowed';
}
